class MainSearch extends SearchForm {
  connectedCallback() {
    // super resolves this.input, which setupEventListeners dereferences; it bails when
    // our markup has not been parsed yet, and then there is nothing to listen on.
    super.connectedCallback();

    this.allSearchInputs = document.querySelectorAll('input[type="search"]');

    if (!this.input || this.mainSearchWired) return;
    this.mainSearchWired = true;

    this.setupEventListeners();
  }

  setupEventListeners() {
    let allSearchForms = [];
    // Only inputs that actually sit in a form: a search input outside one (the search
    // modal has one) reports form === null and threw on addEventListener below.
    this.allSearchInputs.forEach((input) => {
      if (input.form) allSearchForms.push(input.form);
    });
    this.input.addEventListener('focus', this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener('reset', this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener('input', this.onInput.bind(this)));
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync('', this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: 'smooth' });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }
}

customElements.define('main-search', MainSearch);
